import React, { useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import moment from "moment";
import {
    eventStatisticStreamWatchEpisodesGet,
    eventStatisticEventWatchReport,
    eventStatisticRegistrationWatchConversion,
    eventStatisticEventReactions,
} from "../../../../../api/cp";
import Loading from "../../../Loading";
import { useQuery } from "../../../../react-tools";
import { getHumanDuration } from "../../../../tools";
import { getStreamSessions } from "../../../../../common/src/stream";
import {
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Grid,
    OverlayTrigger,
    Row,
    Tooltip
} from "react-bootstrap";
import ViewDurationChart from "./Charts/ViewDurationChart";
import { StreamWatchClients } from "./StreamWatchClients";
import StatisticPieTable from "./StatisticPieTable";
import StatisticHosts from "./StatisticHosts";
import {
    Counter,
    getCounterByName,
    getHostsFromClients,
    getStreamDuration,
    getWatchTime,
    watchDurationKey
} from "./tools";
import CounterComponent from "./CounterComponent";
import EventWatchChart, { convertEventWatches } from "./Charts/EventWatchChart";
import EpisodeTable from "./EpisodeTable";
import ReactionTable from "./ReactionTable";

export default ({ event, type }) => {
    const history = useHistory();
    const { url } = useRouteMatch();
    const query = useQuery();
    const [isLoading, setLoading] = useState(true);
    const [participationType, setParticipationType] = useState('');
    const [watches, setWatches] = useState([]);
    const [clients, setClients] = useState([]);
    const [viewDurations, setViewDurations] = useState([]);
    const [viewCount, setViewCount] = useState(null);
    const [onlineCount, setOnlineCount] = useState(null);
    const [deviceCount, setDeviceCount] = useState(null);
    const [clientCount, setClientCount] = useState(null);
    const [maxOnline, setMaxOnline] = useState(null);
    const [agvViewTime, setAgvViewTime] = useState(null);
    const [commentCount, setCommentCount] = useState(null);
    const [questionCount, setQuestionCount] = useState(null);
    const [episodesStreams, setEpisodesStream] = useState([]);
    const [reactions, setReactions] = useState([]);
    const [registrationConversion, setRegistrationConversion] = useState(0);
    const allStreamsDuration = event.stream.reduce((d, stream) => d + getStreamDuration(stream), 0);
    const streamsDurations = event.stream.reduce((durations, stream) => {
        durations[stream.id] = getStreamDuration(stream);
        return durations;
    }, {});
    const day = null !== query.get('day') ? parseInt(query.get('day')) : null;
    const absoluteStart = day !== null ?
        moment.unix(event.timeStart).add(day, 'days').startOf('day').add(3, 'hours').unix() :
        moment.unix(event.timeStart).startOf('day').add(3, 'hours').unix();
    const absoluteStop = day !== null ?
        moment.unix(event.timeStart).add(day + 1, 'days').startOf('day').add(3, 'hours').unix() :
        moment.unix(event.timeStop).add(1, 'days').startOf('day').add(3, 'hours').unix();
    let rangeStart = 0;
    let rangeStop = event.timeStop - event.timeStart;
    if (null !== day) {
        rangeStart = absoluteStart;
        rangeStop = absoluteStop;
        // rangeStart = moment.unix(event.timeStart).add(day, 'days').startOf('day').add(3, 'hours').unix();
        // rangeStop = moment.unix(event.timeStart).add(day + 1, 'days').startOf('day').add(3, 'hours').unix();
    }

    useEffect(() => {
        setLoading(true);
        setWatches([]);
        setClients([]);
        setViewDurations([]);
        setViewCount(null);
        setOnlineCount(null);
        setDeviceCount(null);
        setClientCount(null);
        setMaxOnline(null);
        setAgvViewTime(null);
        setCommentCount(null);
        setQuestionCount(null);
        setEpisodesStream([]);
        setReactions([]);

        const params = {
            type,
            timeStart: rangeStart,
            timeStop: rangeStop,
        };

        if (participationType) {
            params.participationType = participationType;
        }

        // if (null !== day) {
        //     params.timeStart = rangeStart;
        //     params.timeStop = rangeStop;
        // }

        let reportRequest = eventStatisticEventWatchReport(event.eventPassword, { ...params, timeStart: absoluteStart, timeStop: absoluteStop })
            .then(({ clients, connections, comments, questions }) => {
                setClients(clients);
                setViewCount(connections);
                setCommentCount(comments);
                setQuestionCount(questions);

                if (!clients || clients.length === 0) {
                    return;
                }

                const viewDurations = new Counter();
                let onlineCount = 0;
                let uniqViewDevices = {};
                let uniqClients = {};
                let watchesDurations = 0;

                for (let i = 0; i <= 90; i += 10) {
                    viewDurations.touch(i + '-' + (i + 10));
                }

                clients
                    .forEach((client) => {
                        let isOnline = false;
                        watchesDurations += client.watchesDuration = Object.keys(client.watches)
                            .reduce((watchesDuration, streamId) => {
                                const streamWatches = (client.watches[streamId] || [])
                                    .filter(([, timeStop], index, watches) => null !== timeStop || index === watches.length - 1);

                                if (streamWatches.length && null === streamWatches[streamWatches.length - 1][1]) {
                                    isOnline = true;
                                }

                                return watchesDuration + getWatchTime(streamWatches, 0, streamsDurations[streamId] || 0);
                            }, 0);

                        if (isOnline) {
                            onlineCount++;
                        }
                        if (client.id > 0) {
                            uniqClients[client.id] = true;
                        }
                        uniqViewDevices[client.deviceId] = true;
                        viewDurations.inc(watchDurationKey(client.watchesDuration, allStreamsDuration));
                    });

                if ('live' === type) {
                    let watchIntervals = clients.map(({ timeStart, timeStop }) => ([timeStart, timeStop]));
                    let watches = convertEventWatches(
                        watchIntervals,
                        day === null ? event.timeStart : rangeStart,
                        day === null ? event.timeStop : rangeStop
                    );

                    setWatches(watches);
                    setMaxOnline(watches.reduce((prev, { online }) => Math.max(prev, online), 0));
                } else {
                    setWatches([]);
                    setMaxOnline(null);
                }

                setViewDurations(viewDurations.values);
                setOnlineCount(onlineCount);
                setDeviceCount(Object.keys(uniqViewDevices).length);
                setClientCount(Object.keys(uniqClients).length);
                setAgvViewTime(Math.round(watchesDurations / (clients.length || 1)));
            });

        let episodeReportRequest = eventStatisticStreamWatchEpisodesGet(event.eventPassword, params)
            .then((streams) => {
                setEpisodesStream(streams);
            });

        let reactionsReportRequest = eventStatisticEventReactions(event.eventPassword, { ...params, timeStart: absoluteStart, timeStop: absoluteStop })
            .then((reactions) => {
                setReactions(reactions);
            });

        let registrationConversionRequest = eventStatisticRegistrationWatchConversion(event.eventPassword, params)
            .then(({ percentageConversion: registrationConversion }) => setRegistrationConversion(registrationConversion));

        Promise.all([reportRequest, episodeReportRequest, reactionsReportRequest, registrationConversionRequest])
            .finally(() => setLoading(false));
    }, [event, type, participationType, day]);

    if (isLoading) {
        return <Loading modal>Загрузка данных статистики...</Loading>
    }

    const isEventStarted = event.timeStart <= Date.now() / 1000
        || -1 !== event.stream.findIndex((stream) => getStreamSessions(stream).length > 0)
        ;
    const isEventStopped = event.timeStop <= Date.now() / 1000;
    if ('live' === type && !isEventStarted) {
        return <p style={{ margin: '1em' }}>Статистика будет доступна после начала трансляции</p>
    }
    if ('record' === type && !isEventStopped) {
        return <p style={{ margin: '1em' }}>Статистика будет доступна после окончания трансляции</p>
    }

    const counters = [
        {
            name: 'Всего просмотров',
            count: viewCount,
            tooltip: 'live' === type
                ? 'Кол-во входов (перезагрузок, открытых вкладок) на страницу плеера, при которых были просмотры видео, начавшихся до окончания прямого эфира и посмотревших видео за выбранный период'
                : 'Кол-во входов (перезагрузок, открытых вкладок) на страницу плеера, при которых были просмотры видео, начавшихся после окончания прямого эфира и посмотревших видео за выбранный период',
        },
        {
            name: 'Сейчас смотрит',
            count: onlineCount,
            tooltip: 'live' === type
                ? 'Кол-во зрителей (открытых вкладок) смотрящих видео, зашедших на страницу до окончания прямого эфира'
                : 'Кол-во зрителей (открытых вкладок) смотрящих видео после окончания прямого эфира в зале/эпизоде',
        },
        {
            name: 'Уникальных зрителей',
            count: deviceCount,
            tooltip: 'live' === type
                ? 'Кол-во уникальных устройств просмотра (браузеров), зашедших на страницу до окончания прямого эфира и посмотревших видео за выбранный период'
                : 'Кол-во уникальных устройств просмотра (браузеров), зашедших на страницу после окончания прямого эфира и посмотревших видео за выбранный период',
        },
        {
            name: 'Авторизовано',
            count: '' === type ? clientCount : null,
            tooltip: 'live' === type
                ? 'Кол-во авторизовавшихся зрителей, зашедших на страницу до окончания прямого эфира и посмотревших видео за выбранный период'
                : 'Кол-во авторизовавшихся зрителей, зашедших на страницу после окончания прямого эфира и посмотревших видео за выбранный период',
        },
        {
            name: 'Максимально онлайн',
            count: 'live' === type ? maxOnline : null,
            tooltip: 'live' === type
                ? 'Максимальное кол-во одновременно находившихся на странице плеера зрителей и смотревших видео во время прямого эфира за выбранный период'
                : '',
        },
        {
            name: 'Среднее время просмотра',
            count: getHumanDuration(agvViewTime, true),
            tooltip: 'live' === type
                ? 'Средняя продолжительность просмотра видео всеми зрителями за выбранный период прямого эфира'
                : 'Средняя продолжительность просмотра видео всеми зрителями за выбранный период после окончания прямого эфира',
        },
        {
            name: 'Комментариев',
            count: event.moduleComment.enabled ? commentCount : null,
            tooltip: 'live' === type
                ? 'Кол-во сообщений, прошедших модерацию (если она была включена) и оставленных зрителями за выбранный период прямого эфира во всех залов'
                : 'Кол-во сообщений, прошедших модерацию (если она была включена) и оставленных зрителями за выбранный период после окончания прямого эфира во всех залов',
        },
        {
            name: 'Вопросов',
            count: event.moduleQuestion.enabled ? questionCount : null,
            tooltip: 'live' === type
                ? 'Кол-во сообщений, прошедших модерацию (если она была включена) и оставленных зрителями за выбранный период прямого эфира во всех залов'
                : 'Кол-во сообщений, прошедших модерацию (если она была включена) и оставленных зрителями за выбранный период после окончания прямого эфира во всех залов',
        },
        {
            name: 'Конверсия из зарегистрированных в зрителей',
            count: registrationConversion + '%',
            tooltip: 'live' === type
                ? 'Процент зарегистрированных зрителей, посмотревших прямой эфир'
                : 'Процент зарегистрированных зрителей, посмотревших видео после окончания прямого эфира',
        },
    ];

    const timelineTooltip = 'Показывает совокупное кол-во (по всем залам) зритлей онлайн, входов и выходов на страницу плеера, при которых произошли просмотрты видео. Учитываются только входы на страницу до окончания прямого эфира за выбранный период';
    const viewDurationTooltip = 'Показывает суммарную продолжительность просмотра контента каждым зрителем по отношению к общей продолжительности контента по всем залам';
    const clientsTooltip = 'Уникальные устройства просмотра (браузеры), с которых произошли просмотры записи или прямого эфира. В случае, если зритель прошёл авторизацию, список содержит данные этой авторизации, дополонительных полей и время регистрации.';

    let browsers = getCounterByName(clients, ({ browser, browserVersion }) => browser + ' ' + browserVersion);
    let devices = getCounterByName(clients, ({ device }) => device);
    let countries = getCounterByName(clients, ({ country }) => country);
    let cities = getCounterByName(clients, ({ city }) => city);
    let hosts = getHostsFromClients(clients);
    let downloadClientsUrl = `/api/cp/event/${event.eventPassword}/client.xlsx?type=${type}`;

    const eventDaysCount = moment.duration(moment.unix(Math.min(event.timeStop, Date.now() / 1000)).diff(moment.unix(event.timeStart))).days() + 1;

    const getFilterValue = () => {
        if (null !== day) {
            return `day_${day}`;
        }
    }
    const handleFilterChange = (value) => {
        const [filterType, filterValue] = value.split('_');
        let path = url;
        if (filterType) {
            path += `?${filterType}=${filterValue}`;
        }
        history.push(path);
    }
    const filterOptions = [];
    if ('live' === type && eventDaysCount > 1) {
        for (let i = 0; i < eventDaysCount; i++) {
            filterOptions.push({
                value: `day_${i}`,
                label: `День ${i + 1}: ${moment.unix(event.timeStart + 3600 * 24 * i).format('D MMMM')}`
            });
        }
    }

    return (
        <section style={{ marginTop: '1em' }}>
            <Row>
                {filterOptions.length > 0 && (
                    <Col xs={3}>
                        <FormGroup>
                            <ControlLabel>Интервал</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={getFilterValue()}
                                onChange={(e) => handleFilterChange(e.target.value)}
                            >
                                <option value="">Всё время</option>
                                {filterOptions.map(({ value, label }) => (
                                    <option key={value} value={value}>{label}</option>
                                ))}
                            </FormControl>
                        </FormGroup>
                    </Col>
                )}

                {event.participationType === 'hybrid' && (
                    <Col xs={3}>
                        <FormGroup>
                            <ControlLabel>Формат участия</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Формат участия"
                                value={participationType}
                                onChange={(e) => setParticipationType(e.target.value)}
                            >
                                <option value="">Все</option>
                                <option value="online">Онлайн</option>
                                <option value="offline">Офлайн</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                )}
            </Row>
            {watches?.length > 0 && <section>
                <h4>
                    График захода зрителей на страницу трансляции
                    {' '}
                    <OverlayTrigger placement="top" overlay={<Tooltip id={"timeline-tooltip"}>{timelineTooltip}</Tooltip>}>
                        <Glyphicon glyph="question-sign" />
                    </OverlayTrigger>
                </h4>
                <EventWatchChart watches={watches} episodes={[]} />
            </section>}
            <section>
                <Grid fluid>
                    <Row>
                        {counters.filter(({ count }) => null !== count).map(({ name, count, tooltip }) => (
                            <Col key={name} xs={6} sm={4} md={3} lg={2}>
                                <CounterComponent name={name} count={count} tooltip={tooltip} />
                            </Col>
                        ))}
                    </Row>
                </Grid>
            </section>
            {viewDurations?.length > 0 && <section>
                <h4>
                    Глубина просмотра
                    {' '}
                    <OverlayTrigger overlay={<Tooltip id={`viewDurations-tooltip`}>{viewDurationTooltip}</Tooltip>}>
                        <Glyphicon glyph="question-sign" />
                    </OverlayTrigger>
                </h4>
                <ViewDurationChart viewTime={viewDurations} />
            </section>}
            {clients?.length > 0 && <section>
                <h4>
                    Зрители
                    {' '}
                    <OverlayTrigger placement="top" overlay={<Tooltip id={"timeline-tooltip"}>{clientsTooltip}</Tooltip>}>
                        <Glyphicon glyph="question-sign" />
                    </OverlayTrigger>
                </h4>
                <StreamWatchClients event={event} clients={clients} streamDuration={allStreamsDuration} downloadUrl={downloadClientsUrl} type={type} isSummary />
            </section>}
            {episodesStreams.length > 0 && <section>
                <h4>Просмотр эпизодов</h4>
                <EpisodeTable
                    streams={episodesStreams}
                    eventPassword={event.eventPassword}
                    streamType={type}
                />
            </section>}
            {reactions.length > 0 && (
                <section>
                    <h4>Статистика реакций</h4>
                    <ReactionTable reactions={reactions} />
                </section>
            )}
            <Row>
                <Col xs={6}>
                    <h4>Браузеры</h4>
                    <StatisticPieTable titles={['Браузер', 'Зрители']} data={browsers} title="Браузеры" />
                </Col>
                <Col xs={6}>
                    <h4>Операционные системы</h4>
                    <StatisticPieTable titles={['Система', 'Зрители']} data={devices} title="Операционные системы" />
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <h4>Страны</h4>
                    <StatisticPieTable titles={['Страна', 'Зрители']} data={countries} title="Страны" />
                </Col>
                <Col xs={6}>
                    <h4>Города</h4>
                    <StatisticPieTable titles={['Город', 'Зрители']} data={cities} title="Города" />
                </Col>
            </Row>
            {hosts?.length > 0 && <section>
                <h4>Сайты</h4>
                <StatisticHosts hosts={hosts} />
            </section>}
        </section>
    );
}
